const LINKEDIN_POST_INVALID_CONTENT = 4001;
const LINKEDIN_LONG_POST = 4002;
const LINKEDIN_TOKEN_ERROR = 4011;
const LINKEDIN_POST_UNKNOWN_ERROR = 4220;
const LINKEDIN_MIGRATE_ERROR_ACCOUNT = 4221;
const LINKEDIN_MIGRATE_ERROR_WORKSPACE = 4222;
const LINKEDIN_POST_NO_TEXT = 4223;
const LINKEDIN_POST_DUPLICATE_CONTENT = 4224;
const LINKEDIN_MAXIMUM_ALLOWED_ACCOUNTS_LIMIT_REACHED = 4225;
const LINKEDIN_IMAGE_FORMAT_UNSUPPORTED = 4227;
const LINKEDIN_API_ERROR = 5001;
const CREDIT_CARD_NEEDED_FOR_TRIAL = 4021;
const USER_PLAN_EXPIRED = 4022;
const ORG_ADMIN_PLAN_EXPIRED = 4023;
const ORG_MEMBER_PLAN_EXPIRED = 4024;
const ORG_ADMIN_NO_SUBSCRIPTION = 4025;
const ORG_MEMBER_NO_SUBSCRIPTION = 4026;
const USER_BLOCKED = 4031;

const ERROR_CODES = {
  LINKEDIN_TOKEN_ERROR,
  LINKEDIN_MIGRATE_ERROR_ACCOUNT,
  LINKEDIN_MIGRATE_ERROR_WORKSPACE,
  LINKEDIN_MAXIMUM_ALLOWED_ACCOUNTS_LIMIT_REACHED,
  LINKEDIN_POST_UNKNOWN_ERROR,
  LINKEDIN_POST_INVALID_CONTENT,
  LINKEDIN_LONG_POST,
  LINKEDIN_POST_NO_TEXT,
  LINKEDIN_POST_DUPLICATE_CONTENT,
  LINKEDIN_IMAGE_FORMAT_UNSUPPORTED,
  LINKEDIN_API_ERROR,
  CREDIT_CARD_NEEDED_FOR_TRIAL,
  USER_PLAN_EXPIRED,
  ORG_ADMIN_PLAN_EXPIRED,
  ORG_MEMBER_PLAN_EXPIRED,
  ORG_ADMIN_NO_SUBSCRIPTION,
  ORG_MEMBER_NO_SUBSCRIPTION,
  USER_BLOCKED,
};

export { ERROR_CODES };
